"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
// import app components
const textarea_1 = __importDefault(require("../../elements/textarea"));
const paper_1 = __importDefault(require("../../elements/paper"));
const Policy = (props) => {
    const { children, linkComponent } = props;
    return (react_1.default.createElement(material_1.Container, { maxWidth: "md", sx: { py: 5 } },
        react_1.default.createElement(paper_1.default, null, children && react_1.default.createElement(textarea_1.default, { linkComponent: linkComponent }, children))));
};
exports.default = Policy;
